import { Container, Grid } from "@mui/material";
import AcxButton from "components/UI/AcxButton";
import { Observer } from "mobx-react";
import React from "react";
import { AuthStore } from "stores/AuthStore";
import { ClipUIModel } from "../../../models/SoundClip";
import SoundClipEditor from "../../SoundClipEditor/SoundClipEditor";
import MontageClip from "../MontageClip";
import {
    MontageSoundClipStore,
    UpdateMontageOp,
} from "../Stores/MontageSoundClipStore";
import theme from "Theme/AppTheme";

export default function MontageClipEditor(props: {
    store: MontageSoundClipStore;
    authStore: AuthStore;
}) {
    return (
        <Observer>
            {() => (
                <Container maxWidth={false}>
                    <Grid
                        container
                        direction="column"
                        justifyContent="center"
                        alignItems="stretch"
                        spacing={1}
                    >
                        <Grid item container justifyContent={"flex-end"}>
                            {props.store.combinedClip
                                ? [
                                      <Grid item key={"reset-btn-grid"}>
                                          <AcxButton
                                              fullWidth
                                              key={"reset-btn"}
                                              onClick={props.store.resetMontage}
                                              style={{
                                                  padding: "1rem",
                                                  minWidth: "max-content",
                                              }}
                                              color="white"
                                              disabled={props.store.getTaskLoading(
                                                  UpdateMontageOp,
                                              )}
                                          >
                                              Back
                                          </AcxButton>
                                      </Grid>,
                                      <Grid item key={"export-btn-grid"}>
                                          {!props.store.isEditMontage ? (
                                              <AcxButton
                                                  fullWidth
                                                  key={"export-btn"}
                                                  onClick={
                                                      props.store.openSaveDialog
                                                  }
                                                  style={{
                                                      padding: "1rem",
                                                      minWidth: "max-content",
                                                      marginRight:
                                                          theme.spacing(1),
                                                      marginLeft:
                                                          theme.spacing(1),
                                                  }}
                                              >
                                                  Save
                                              </AcxButton>
                                          ) : (
                                              <AcxButton
                                                  fullWidth
                                                  key={"export-btn"}
                                                  loading={props.store.getTaskLoading(
                                                      UpdateMontageOp,
                                                  )}
                                                  onClick={
                                                      props.store.updateMontage
                                                  }
                                                  style={{
                                                      padding: "1rem",
                                                      minWidth: "max-content",
                                                      marginRight:
                                                          theme.spacing(1),
                                                      marginLeft:
                                                          theme.spacing(1),
                                                  }}
                                              >
                                                  Update
                                              </AcxButton>
                                          )}
                                      </Grid>,
                                  ]
                                : [
                                      <Grid item key={"merge-clips-grid"}>
                                          <AcxButton
                                              fullWidth
                                              key={"merge-clips"}
                                              loading={
                                                  props.store.anyClipsLoading
                                              }
                                              disabled={
                                                  !props.store.soundClipDgStore
                                                      .selectedRows.length ||
                                                  props.store.anyClipsLoading ||
                                                  !props.store
                                                      .allSelectedClipsReady
                                              }
                                              onClick={
                                                  props.store.generateMontage
                                              }
                                              style={{
                                                  padding: "1rem",
                                                  minWidth: "max-content",
                                              }}
                                              color="primary"
                                          >
                                              Preview Montage
                                          </AcxButton>
                                      </Grid>,
                                  ]}
                        </Grid>

                        {props.store.combinedClip ? (
                            <Grid
                                item
                                key={
                                    "montage-clip-grid-" +
                                    props.store.combinedClip?.id
                                }
                            >
                                <MontageClip
                                    renderAudioEditor={() => (
                                        <SoundClipEditor
                                            id={props.store.combinedClip?.id!}
                                            index={0}
                                            clip={
                                                props.store
                                                    .combinedClip as ClipUIModel
                                            }
                                            clipAudioBuffer={
                                                props.store.combinedBuffer
                                            }
                                            clipBlob={props.store.combinedBlob}
                                            onClipLoading={
                                                props.store.setClipLoading
                                            }
                                            onAudioBufferReady={(arg) =>
                                                (props.store.combinedBuffer =
                                                    arg.audioBuffer)
                                            }
                                            enableZoom
                                            isMontage
                                        />
                                    )}
                                    id={props.store.combinedClip?.id}
                                    index={0}
                                    store={props.store}
                                    moveCard={props.store.moveCard}
                                    onDelete={
                                        props.store.removeSelectedClipById
                                    }
                                    key={
                                        "montage-clip-" +
                                        props.store.combinedClip?.id
                                    }
                                    clip={props.store.combinedClip}
                                    hideControls
                                    showUndo
                                    showRedaction={false}
                                />
                            </Grid>
                        ) : (
                            props.store.tabIndex === 1 &&
                            props.store.soundClipDgStore.selectedRows.map(
                                (clip: any, index) => {
                                    // montageSoundClipPath is set by the store when a montage's edited clips load
                                    var clipUiModel = clip as ClipUIModel;

                                    return (
                                        <Grid
                                            item
                                            key={"montage-clip-grid-" + clip.id}
                                        >
                                            <MontageClip
                                                renderAudioEditor={() => (
                                                    <SoundClipEditor
                                                        id={clip.id}
                                                        index={index}
                                                        clip={clipUiModel}
                                                        clipAudioBuffer={
                                                            props.store.clipsRedacted.find(
                                                                (value) => {
                                                                    return (
                                                                        value ===
                                                                        clip.id
                                                                    );
                                                                },
                                                            ) !== undefined
                                                                ? props.store.audioBuffersSet.get(
                                                                      clip.id,
                                                                  )
                                                                      ?.redactedAudioBufer
                                                                : props.store.audioBuffersSet.get(
                                                                      clip.id,
                                                                  )?.audioBuffer
                                                        }
                                                        onClipLoading={
                                                            props.store
                                                                .setClipLoading
                                                        }
                                                        onAudioBufferReady={
                                                            props.store
                                                                .addAudioBufferToSet
                                                        }
                                                        enableZoom
                                                        isMontage
                                                    />
                                                )}
                                                id={clip.id}
                                                index={index}
                                                store={props.store}
                                                moveCard={props.store.moveCard}
                                                onDelete={
                                                    props.store
                                                        .removeSelectedClipById
                                                }
                                                key={"montage-clip-" + clip.id}
                                                clip={clip}
                                                showRedaction={props.authStore.canUserEdit(
                                                    "Clip Redaction",
                                                )}
                                            />
                                        </Grid>
                                    );
                                },
                            )
                        )}
                    </Grid>
                </Container>
            )}
        </Observer>
    );
}
